import React from "react";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";

type TreatmentCardProps = {
  treatmentName: string;
  image: string;
  onClick?: () => void;
};

const TreatmentCard: React.FC<TreatmentCardProps> = ({
  treatmentName,
  image,
  onClick,
}) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        width: "100%",
        maxWidth: 300,
        margin: "0 auto",
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: onClick ? "translateY(-4px)" : "none",
          boxShadow: onClick
            ? "0 12px 24px rgba(7, 73, 116, 0.16)"
            : undefined,
        },
      }}
    >
      <CardMedia
        component="img"
        height="230"
        image={image}
        alt={treatmentName}
        loading="lazy"
        sx={{
          objectFit: "cover",
          objectPosition: "center",
        }}
      />
      <CardContent>
        <Typography
          variant="h6"
          component="div"
          textAlign="center"
          color="secondary.main"
        >
          {treatmentName}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default TreatmentCard;
